import { Tooltip, Legend } from "dependencies/bigScreen/publicChartOptions/options"
export const chartOption1 = {
  styleId:1,
  pluginName: ["formatterValToPercentage"],
  isShowDataName: true, // 是否显示数据名称  单独列出来是因为formatter里面取不到百分比的值，formatter使用插件 function, 因此回显无法判断
  refreshTime: 90000,
  seriesTempAttributes: {
    // 用于存放数据中的通用配置项
    coordinateType: "" //不带坐标系
  },
  title: {
    text: "title",
    left: "center",
    show: false
  },
  tooltip: new Tooltip("item", { show: false }),
  legend: new Legend({
    show: false,
    left: "center",
    top: "top",
    textStyle: {
      color: "rgba(255,255,255,1)",
      fontWeight: "400",
      fontSize: 14
    }
  }),
  series: [
    {
      name: "外部刻度",
      type: "gauge",
      radius: "90%",
      min: 0,
      max: 100,
      splitNumber: 10,
      startAngle: 245,
      endAngle: -65,
      axisLine: {
        roundCap: true,
        lineStyle: {
          width: 0,
          opacity: 0,
          color: [[1, "rgba(0, 0, 0, 0.8)"]]
        }
      },
      axisLabel: {
        show: true,
        distance: 5,
        color: "rgba(0, 0, 0, 0.5)",
        fontSize: 12,
        fontWeight: "normal",
        fontFamily: "sans-serif"
      },
      axisTick: {
        show: true,
        splitNumber: 5,
        lineStyle: {
          color: "auto",
          width: 1
        },
        length: 3
      },
      splitLine: {
        show: true,
        length: 6,
        distance: 9,
        lineStyle: {
          color: "auto",
          width: 1
        }
      },
      detail: {
        show: false
      },
      pointer: {
        show: false
      }
    },
    {
      name: "内部（环形）进度条",
      type: "gauge",
      radius: "60%",
      z: 4,
      startAngle: 245,
      endAngle: -65,
      axisLine: {
        lineStyle: {
          color: [
            [
              0.19,
              {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(1, 209, 232, 1)"
                  },
                  {
                    offset: 1,
                    color: "rgba(1, 80, 254, 1)"
                  }
                ],
                globalCoord: false
              }
            ]
          ],
          width: 12
        }
      },
      axisLabel: {
        show: false
      },
      axisTick: {
        show: false
      },
      splitLine: {
        show: false
      },
      pointer: {
        show: false
      },
      title: {
        show: true,
        offsetCenter: ["0%", "20%"],
        fontSize: 16,
        color: "#fff",
        height: 24
      },
      detail: {
        show: true,
        color: "#fff",
        fontSize: 40,
        fontWeight: "bold",
        fontFamily: "sans-serif",
        offsetCenter: ["0%", "-10%"],
        formatter: "{value}{valueUnit|}",
        rich: {
          valueUnit: { fontSize: 12, fontWeight: "400", fontFamily: "sans-serif", color: "rgba(255,255,255,1)" }
        }
      },
      data: [
        {
          name: 202103,
          value: 19
        }
      ]
    },
    {
      name: "内部（环形）进度条背景",
      type: "gauge",
      radius: "64%",
      z: 3,
      startAngle: 245,
      endAngle: -65,
      axisLine: {
        lineStyle: {
          color: [[1, "rgba(0, 0, 0, 0.06)"]],
          width: 18
        }
      },
      axisLabel: {
        show: false
      },
      axisTick: {
        show: false
      },
      splitLine: {
        show: false
      },
      detail: {
        show: false
      }
    },
    {
      type: "pie",
      radius: ["0", "42%"],
      itemStyle: {
        color: "#088AD5"
      },
      labelLine: {
        show: false
      },
      hoverAnimation: false,
      data: [1]
    }
  ]
}
